// cost of the home after the given years, the cost today grows by the property inflation rate (in %)
export const _getHomeFutureCost = (home_cost, property_inflation, years) => {
    return (Number(home_cost) || 0) * Math.pow(1 + (Number(property_inflation) || 0) / 100, years);
};

// monthly EMI of the loan, the loan rate is the annual rate in %
export const _getHomeLoanEmi = (loan_amount, loan_rate, loan_years) => {
    const months = loan_years * 12;
    const monthly_rate = (Number(loan_rate) || 0) / 100 / 12;

    if (months <= 0) {
        return 0;
    }

    if (monthly_rate === 0) {
        return loan_amount / months;
    }

    const growth = Math.pow(1 + monthly_rate, months);
    return loan_amount * monthly_rate * growth / (growth - 1);
};
